<template>
  <div>
    <img src="@/assets/tarjeta_servicios_seguro_salud.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE SALUD</p>

    <p>
      Entra en tu seguro y empieza a disfrutar de nuestros servicios
    </p>

    <ul style="list-style-type: disc">
      <li>Consulta el cuadro médico.</li>
      <li>Gestiona tus citas.</li>
      <li>Autoriza volantes.</li>
      <li>Mucho más...</li>
    </ul>

    <p class="container-flex">
      <a href="tel: +34 91 594 88 76">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a HNA">
          Llamar
        </button>
      </a>

      <button class="pure-button botonLlamar" @click.prevent="openAreaClienteSaludHna()">Entrar</button>

    </p>

  </div>
</template>

<script>
export default {
  computed: {
    idCliente() {
      return this.$store.state.portfolio.idCliente
    }
  },
  methods: {
    email() { },

    openAreaClienteSaludHna() {
      this.$store.dispatch("openAreaClienteSaludHna", this.idCliente);
    }
  },
};
</script>
<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  text-align: center;
  border-radius: 0.5rem;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
